<div class="wrapper">
    <ng-content/>
</div>